<template>
	<article class="small-12" v-highlight v-if="event">
        <pre class="flex">
            <code class="small-12 json" v-if="event.attributes.response.data.object.object !== 'charge'">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        payment_method: {
            billing_details: {
                name: "{{event.attributes.request.payment_method.billing_details.name}}"
            },
            setup_future_usage: "{{event.attributes.request.setup_future_usage}}"
        },
        stripe: {
            amount: {{event.attributes.response.data.object.amount | convertCentsToDollars}},
            canceled_at: "{{event.attributes.response.data.object.canceled_at}}",
            cancellation_reason: "{{event.attributes.response.data.object.cancellation_reason}}",
            capture_method: "{{event.attributes.response.data.object.capture_method}}",
            confirmation_method: "{{event.attributes.response.data.object.confirmation_method}}",
            created: "{{event.attributes.response.data.object.created | unixToDateTime}}",
            currency: "{{event.attributes.response.data.object.currency}}",
            description: "{{event.attributes.response.data.object.description}}",
            id: "{{event.attributes.response.data.object.id}}",
            last_payment_error: "{{event.attributes.response.data.object.last_payment_error}}",
            next_action: "{{event.attributes.response.data.object.next_action}}",
            object: "{{event.attributes.response.data.object.object}}",
            payment_method_types: [
                "{{event.attributes.response.data.object.payment_method_types[0]}}"
            ],
            receipt_email: "{{event.attributes.response.data.object.receipt_email}}",
            setup_future_usage: "{{event.attributes.response.data.object.setup_future_usage}}",
            status: "{{event.attributes.response.data.object.status}}",
        }
    }
}
            </code>
            <code class="small-12 json" v-if="event.attributes.response.data.object.object == 'charge'">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        payment_method: {
            billing_details: {
                name: "{{event.attributes.request.payment_method.billing_details.name}}"
            },
            setup_future_usage: "{{event.attributes.request.setup_future_usage}}"
        },
        stripe: {
            amount: {{event.attributes.response.data.object.amount | convertCentsToDollars}},
            canceled_at: "{{event.attributes.response.data.object.canceled_at}}",
            cancellation_reason: "{{event.attributes.response.data.object.cancellation_reason}}",
            capture_method: "{{event.attributes.response.data.object.capture_method}}",
            confirmation_method: "{{event.attributes.response.data.object.confirmation_method}}",
            created: "{{event.attributes.response.data.object.created | unixToDateTime}}",
            currency: "{{event.attributes.response.data.object.currency}}",
            description: "{{event.attributes.response.data.object.description}}",
            id: "{{event.attributes.response.data.object.id}}",
            last_payment_error: "{{event.attributes.response.data.object.last_payment_error}}",
            next_action: "{{event.attributes.response.data.object.next_action}}",
            object: "{{event.attributes.response.data.object.object}}",
            receipt_email: "{{event.attributes.response.data.object.receipt_email}}",
            setup_future_usage: "{{event.attributes.response.data.object.setup_future_usage}}",
            status: "{{event.attributes.response.data.object.status}}",
        }
    }
}
            </code>
        </pre>
	</article>
</template>

<script>

    // Import the mixins
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'InvoicePaymentEventResponse',

		/*
		**  Register the mixins
		*/

		mixins: [

            MoneyConversions,
            DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			event: {
				type: Object,
				default: () => null
			}

		}

	}

</script>